<template lang="pug">
.stack
  transition-group(name="fade")
    g-dialog.opacity-transition(v-for="(d, i) in stack", :key="Id(d)", :appear="true", :closable="d.closable", @close="d.onClose")
      div(:is="d.component", v-bind="d.props", @resolve="d.resolve", @reject="d.reject")
</template>

<script>
export default {
  props: ['stack'],
}
</script>

<style lang="scss" scoped>
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}

.opacity-transition {
  transition: opacity 0.2s;
}
</style>